<template>
  <div>
		<div class="calendar-header">
			<div class="calendar-header-date">
				<h1>{{selectedMonth}}</h1>
				<input style="width:70px;" :value="selectedYear" type="number" readonly="true">
			</div>
			<div class="calendar-right" @click="SetNextMonth(true)"></div>
			<div class="calendar-left" @click="SetNextMonth(false)"></div>
		</div>
		<div class="calendar-week">
			<div class="calendar-day-header" v-for="(staticDay, index) in staticDays" :key="index">{{staticDay}}</div>
		</div>
		<div class="calendar-month">
			<div class="calendar-week" v-for="(week, index) in weeks" :key="index">
				<div :class="day.state" v-for="(day, index) in week" :key="index" @mousedown="OnPickDate(day)">
					<div class="calendar-day-number" :class="day.isToday ? 'today' : ''">{{day.num}}</div>
					<div class="calendar-events" v-if="hasEvents"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
		hasEvents:Boolean
	},
	data() {
		return {
			staticDays : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			selectedMonth : null,
			selectedYear : null,
			weeks : []
		}
	},
	methods: {
		SetNextMonth:function(flag) {
			if (flag) { this.current.add(1, 'months'); }
			else { this.current.subtract(1, 'months'); }
			this.Refresh();
		},
		OnPickDate:function(day) {
			this.$emit('OnPickDate', day);
		}
	},
	mounted: function(){
		this.today = moment();
		this.current = moment().date(1);

		this.Refresh = function() {
			this.selectedMonth = this.current.format('MMMM');
			this.selectedYear = this.current.format('YYYY');
			this.SetMonth();
		}

		this.BackFill = function() {
			var clone = this.current.clone();
			var dayOfWeek = clone.day();
			if(!dayOfWeek) { return; }
			clone.subtract(dayOfWeek + 1, 'days');
			for(var i = dayOfWeek; i > 0 ; --i) {
			  	this.SetDay(clone.add(1, 'days'));
			}
		}

		this.ForwardFill = function() {
			var clone = this.current.clone().add(1, 'months').subtract(1, 'days');
			var dayOfWeek = clone.day();
			if(dayOfWeek === 6) { return; }
			for(var i = dayOfWeek; i < 6 ; ++i) {
				this.SetDay(clone.add(1, 'days'));
			}
		}

		this.SetMonth = function() {
			this.weeks = [];
			//back fill
			this.BackFill();
			//fill with days
			var clone = this.current.clone();
			while(clone.month() === this.current.month()) {
				this.SetDay(clone);
				clone.add(1, 'days');
			}
			//forward fill
			this.ForwardFill();
		}

		this.GetWeek = function(day) {
			if (day.day() === 0) { this.weeks.push([]); }
			return this.weeks[this.weeks.length - 1];
		}

		this.SetDay = function(day) {
			var curWeek = this.GetWeek(day);
			var d = {};
			d.num = day.format('D');
			d.day = day.format('DD-MM-YYYY');
			d.formatted = day.format('YYYY-MM-DD');
			d.state = 'calendar-day';
			if(day.month() !== this.current.month()) { d.state += ' other'; }
			else if (this.today.isSame(day, 'day')) {
				d.state += ' today';
				d.isToday = true;
			}
			curWeek.push(d);
		}

		this.Refresh();
	}
}
</script>

<style scoped>
@-webkit-keyframes fadeIn  {
  from { opacity: 0; }
  to { opacity: 1; }
}
@-moz-keyframes fadeIn  {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes fadeIn  {
  from { opacity: 0; }
  to { opacity: 1; }
}
#calendar {
  margin: 0 auto;
  overflow: hidden;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  border: 1px solid #dedede;
}
.calendar-picker {
  max-width: 300px;
  background:white;
  position:absolute;
  box-shadow: 0 2px 15px 0 rgba(16, 37, 133, 0.1);
}
.calendar-header {
  text-align: center;
  position:relative;
}
.calendar-header-date {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-header-date h1, .calendar-header-date input {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 19px;
  letter-spacing: 1px;
  font-weight: 100;
}
.calendar-header-date input {
  background: transparent;
  border: none;
  width: 60px;
}
.calendar-left, .calendar-right {
  position: absolute;
  width: 0px;
  height: 0px;
  border-style: solid;
  top: 50%;
  margin-top: -7.5px;
  cursor: pointer;
}
.calendar-left {
  border-width: 7.5px 10px 7.5px 0;
  border-color: transparent rgba(160, 159, 160, 1) transparent transparent;
  left: 20px;
}
.calendar-right {
  border-width: 7.5px 0 7.5px 10px;
  border-color: transparent transparent transparent rgba(160, 159, 160, 1);
  right: 20px;
}
.calendar-month {
  border: 0.5px solid #dedede;
}
.calendar-week {
  display: -webkit-flex;
  display: flex;
}
.calendar-day, .calendar-day-header {
  flex : 1;
  text-align: center;
  position: relative;
}
.calendar-day {
  cursor: pointer;
  border: 1px solid #dedede;
  min-height: 30px;
}
.calendar-day:hover {
  background-color: rgba(94, 130, 152, 0.1);
}
.calendar-day.other {
 color: #bdc3c7;
}
.calendar-day.today {
  color: white;
}
.calendar-day-number {
  font-size: 15px;
  letter-spacing: 1.5px;
  position: absolute;
  top: 5px;
  right: 5px;
}
.calendar-day-number.today {
  border-radius: 20px;
  background: #001b3d;
}
.calendar-events {
  flex : 1 1 auto;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  padding-top: 30px;
  min-height: 100px;
}
.calendar-event {
  height: 10px;
  cursor: pointer;
  color:white;
  margin:1px;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-event-text {
  font-weight: bold;
  font-size: 10px;
}
.calendar-event.libur {
  background-color: red;
}
.calendar-event.kegiatan {
  background-color: #3498db;
}
.calendar-event.ujian {
  background-color: green;
}
.calendar-event.tugas {
  background-color: #001b3d;
}
.calendar-fade-in {
  -webkit-animation: fadeIn .5s ease both;
  -moz-animation: fadeIn .5s ease both;
  animation: fadeIn .5s ease both;
}
@media all and (max-width: 1024px){
  .calendar-event-text {
    font-size: 0px;
  }
}
@media all and (max-width: 768px){
  .calendar-event {
    max-width: 30px;
  }
}
</style>
